import { PlatformType } from "../helpers/subdomainHelpers/getPlatformType";
import { markCurrentOfferBooked } from "./marketplaceSession";
import { pushMarketplaceContext } from "./pushMarketplaceContext";
import { MarketplaceAirlineContextInput, MarketplaceContextPayload, MarketplaceHotelContextInput } from "./types";

type TenantInfoLike = {
  code?: string | null;
  name?: string | null;
} | null;

export type PushTransportBookMarketplaceContextInput = {
  cookieAccepted?: boolean | null;
  platformType: PlatformType;
  tenantInfo?: TenantInfoLike;
  offerCode?: string | null;
  airline?: MarketplaceAirlineContextInput;
};

/**
 * Consent-gated DataLayer push for transport Book / Buy CTAs.
 * Includes `offer_code`, hotel/airline context, and session `source` / `source_detail`.
 * Airline airport/date/M&M fall back to persisted router state when `airline` is omitted.
 */
export const pushTransportBookMarketplaceContext = ({
  cookieAccepted,
  platformType,
  tenantInfo,
  offerCode,
  airline
}: PushTransportBookMarketplaceContextInput): MarketplaceContextPayload | null => {
  markCurrentOfferBooked();

  const hotel: MarketplaceHotelContextInput | undefined =
    platformType === "hotel"
      ? {
          id: tenantInfo?.code ?? null,
          name: tenantInfo?.name ?? null
        }
      : undefined;

  return pushMarketplaceContext({
    action: "book_transport",
    cookieAccepted,
    platformType,
    hotel,
    airline,
    offerCode
  });
};
